import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/groupBy';
import 'rxjs/add/operator/do';
import {Container} from 'semantic-ui-react';
import DocumentTitle from 'react-document-title';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';

import MultiPlatformResourceForm from 'components/forms/MultiPlatformResourceForm';
import BreakConfig from 'components/EditContent/configs/breaks/breaksConfig';
import BreakSummary from 'components/common/BreakSummary';
import PublishBreakModalContainer from 'pages/BreakPublish/PublishBreakModalContainer';
import ValidateBreakModalContainer from 'pages/BreakPublish/ValidateBreakModalContainer';
import {isNoU, isTruthy} from "utils/DBUtils";
import ResourceAccordion from "components/common/ResourceAccordion";
import ImageEditModalContainer from "../Images/ImageEditModalContainer";
import ImageUploadModalContainer from "../Images/ImageUploadModalContainer";
import ImageRecropModalContainer from "../Images/ImageRecropModalContainer";
import UploadOriginalEditImageModalContainer from "pages/Images/UploadOriginalEditImageModalContainer";
import StoreFinderImportModalContainer from "pages/StoreFinderImport/StoreFinderImportModalContainer";
import UnpublishBreakModalContainer from "../BreakPublish/UnpublishBreakModalContainer";
import VerifyUnpublishChallengeModal from "../BreakPublish/VerifyUnpublishChallengeModal";
import CopyBreakModalContainer from 'pages/BreakCopy/CopyBreakModalContainer';
import LoadingSpinner from "../../components/common/LoadingSpinner";
import BreakTagModal from "./BreakTagModal/BreakTagModal";
import DeleteBreakTagModal from "./DeleteBreakTagModal/DeleteBreakTagModal";

/*

  permalink: string,
  type: string,
  title: string,
  description: string ( textarea ),
  meta description: string ( textarea ),
  display date: date,
  display time: date/time ( combine above? ),
  start date: date/time,
  end date: date/time,
  usernames: string array,
  hideOnHomepage: bool,
  category filter: bool,
  guest access: bool,
  number of spots: number,
  gross revenue per start: double,
  resize target url: string

*/

class EditBreakPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeAccordion: 0
        };

        this.secretLoader = false;
    }

    componentWillMount() {
      var secretChance = Math.random();

      if (secretChance > 0.98) { //2% Chance
        this.secretLoader = true;
      }
    }

  isFeatured() {
    var breakMapKeys = Object.keys(this.props.break);
    var isFeatured = false;

    breakMapKeys.map((key) => {
      if (this.props.break[key].featured) {
        isFeatured = true;
      }
    });

    return isFeatured;
  }

  render() {
    const master = get(this.props, 'break.MASTER', {});
    const dailybreak = get(this.props, 'break.DAILYBREAK', null);

    let title = master.title ? master.title : master.permalink;
    const showLoader = !title || this.props.searchInProgress;
    const showBreak = this.props.break && this.props.break.MASTER && !this.props.searchInProgress;

    if ( !title ) {
      title = this.props.intl.formatMessage({ id: 'loading.break' });
    }

    let points = master.possibleCoinsAwarded;
    if (isNoU(points) || isNoU(dailybreak)) {
      points = "N/A";
    }

    const webPublishStatus = get(this.props.break, 'DAILYBREAK.publishStatus', null);

    return (
      <DocumentTitle title={title}>
        <Container text className="edit-break-page-container">
          {
            showLoader ?
            (!this.secretLoader ?
                <LoadingSpinner textKey={'break'}/>
              :
                <div className="loading-spinner fadeInDown animResponse">
                  <img src="http://rsmg.pbsrc.com/albums/v642/exactoman/Animated%20GIFs/Video%20Game%20GIFs/Sonic/thsonicrunning.gif~c200"/>
                  <p>Loading at Sonic Speed</p>
                </div>
              )
            : ""
          }

          {showBreak ? (
            <div className="db-edit-break-page">
              <BreakSummary
                header={master.permalink || ''}
                breakType={master.sponsoredType || 'N/A'}
                title={master.title}
                permalink={master.permalink}
                lang={master.lang}
                challengeId={master.challengeId}
                showViewAllLink={master.sponsoredType !== 'editorial'}
                showUnpublishLink={master.sponsoredType === 'editorial'}
                showMasterLink={false}
                site={master.lang || 'N/A'}
                userCanPublish={this.props.userCanPublishBreaks}
                userCanUnpublish={this.props.userCanUnpublishBreaks}
                userCanViewAnalytics={this.props.userCanViewAnalytics}
                showCopyBreakModal={() => this.props.showCopyBreakModal(master)}
                points={points}
                featured={this.props.break ? (this.isFeatured() ? 'Yes' : 'No') : 'N/A'}
                publishChallenge={ () => this.props.publishChallenge(master.challengeId, (this.props.break ? Object.keys(this.props.break) : []), master) }
                canUnpublishEditorial={webPublishStatus === 'LIVE' || webPublishStatus === 'READY'}
                unpublishChallenge={() => this.props.unpublishChallenge(master.challengeId, (this.props.break ? Object.keys(this.props.break) : []), master)}
                challengeIsPublishing={this.props.challengeIsPublishing && (this.props.platformsBeingPublished != null && (this.props.platformsBeingPublished.length > 1 || Object.keys(this.props.break).length === 1))}
                validateChallenge={ () => this.props.validateChallenge(master, this.props.break ? Object.keys(this.props.break) : []) }
                challengeIsValidating={this.props.challengeIsValidating && (this.props.platformsBeingValidated != null && (this.props.platformsBeingValidated.length > 1 || Object.keys(this.props.break).length === 1))} />
              <MultiPlatformResourceForm
                reducerKey={this.props.reducerKey}
                openSection={this.props.openSection}
                config={BreakConfig}
                staticRender={true}
                userGroup={this.props.userGroup}
                sectionWrapper={ResourceAccordion}
                currentPlatform={this.props.currentPlatform}
                resource={this.props.break} />
              <PublishBreakModalContainer />
              <UnpublishBreakModalContainer />
              <VerifyUnpublishChallengeModal />
              <ImageEditModalContainer />
              <ImageUploadModalContainer />
              <ImageRecropModalContainer />
              <ValidateBreakModalContainer />
              <UploadOriginalEditImageModalContainer enableBulkUpload />
              <StoreFinderImportModalContainer/>
              <CopyBreakModalContainer key="CopyBreakModal"/>
              <BreakTagModal />
              <DeleteBreakTagModal />
              <br/>
              <br/><br/><br/><br/><br/><br/><br/>
            </div>) : ""}
        </Container>
      </DocumentTitle>
    );
  }
}

EditBreakPage.propTypes = {
    break: PropTypes.object,
    addStep: PropTypes.func,
    deleteStep: PropTypes.func,
    intl: intlShape.isRequired,
    syncMaster: PropTypes.func,
    currentPlatform: PropTypes.string.isRequired,
    persistValue: PropTypes.func.isRequired
};

export default injectIntl(EditBreakPage);



// WEBPACK FOOTER //
// ./public/pages/EditBreak/EditBreakPage.jsx